import { atom } from 'jotai';

export const organizationSearchResultsAddedCompaniesState = atom<string[]>([]);

export const organizationSearchResultsCompaniesBusyState = atom<string[]>([]);
